import { observable, computed, extendObservable, action } from 'mobx';

export default class SaleEditStore {
  @observable page = 1;
  @observable offerData = {};
  @observable docs = [];

  user = null;

  constructor(user) {
    this.user = user;
  }

  @computed get isPage1Valid() {
    const data = this.offerData;
    return !!data.object_type && !!data.object_address;
  }

  @computed get isPage2Valid() {
    return true;
  }

  @action initialize(offerData, docs) {
    this.offerData = Object.assign({}, offerData);
    this.docs = (docs || []).slice();
    extendObservable(this.offerData, {
      object_type: offerData.object_type || '',
      objectno: offerData.objectno || '',
      object_address: offerData.object_address || '',
    });
  }
}

export { SaleEditStore };



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_gb/stores/index.js